const translations = {
  "en": {
    "Ask Ed": "Ask Ed"
  },
  "zh-tw": {
    "Ask Ed": "問問 Ed"
  }
};

export default translations;
